import { render } from "./DeletionModal.vue?vue&type=template&id=1c75f2a1&scoped=true"
import script from "./DeletionModal.vue?vue&type=script&lang=js"
export * from "./DeletionModal.vue?vue&type=script&lang=js"

import "./DeletionModal.vue?vue&type=style&index=0&id=1c75f2a1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c75f2a1"]])

export default __exports__